__turbopack_context__.v({
  "container": "IndustryReports-module-scss-module__Sa2jta__container",
  "industryReports": "IndustryReports-module-scss-module__Sa2jta__industryReports",
  "seeAll": "IndustryReports-module-scss-module__Sa2jta__seeAll",
});
